module.exports = __webpack_public_path__ + "img/2.6d2a9acf.png";